/**
 * The Determination Simulator route (FSD cross-feature, SCR-X-SIM).
 *
 * The router spread and the nav entry belong to the integration step, which
 * owns `web/src/router/**` and `web/src/nav/**`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { SIMULATOR_PERMISSIONS } from '@/modules/enterprise/simulator/permissions'

export const DETERMINATION_SIMULATOR_PATH = '/enterprise/determination-simulator'

export function determinationSimulatorRoute(): string {
  return DETERMINATION_SIMULATOR_PATH
}

export const ENTERPRISE_SIMULATOR_ROUTES: RouteRecordRaw[] = [
  {
    path: DETERMINATION_SIMULATOR_PATH,
    name: 'enterprise-determination-simulator',
    component: () => import('@/modules/enterprise/simulator/DeterminationSimulatorView.vue'),
    meta: {
      titleKey: 'enterprise.simulator.routeTitles.simulator',
      permission: SIMULATOR_PERMISSIONS.read,
    },
  },
]
